import React, { useEffect, useState } from "react";
import { headerOptions } from "../JsonFiles/Header";
import "./Header.scss";
import user from "../JsonFiles/simran.json"

const Header = (props) => {
  const [theme, setTheme] = useState("light");

  const fnChangeTheme = () => {
    if (theme === "light") {
      setTheme("dark");
    } else {
      setTheme("light");
    }
  };
  useEffect(() => {
    const bodyElt = document.querySelector("body");
    if (theme === "light") {
      bodyElt.style.backgroundColor = "white";
    } else {
      bodyElt.style.backgroundColor = "black";
    }
    props?.themeChange(theme);
  }, [theme]);

  return (
    <div className="header-main">
      <nav class={`navbar navbar-expand-lg bg-${theme} navbar-${theme}`}>
        <div class="container-fluid">
          <a class="navbar-brand">
            {user.name}
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapsibleNavbar"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div
            class="collapse navbar-collapse justify-content-end"
            id="collapsibleNavbar"
          >
            <ul class="navbar-nav ">
              {headerOptions?.map((option,id) => (
                <li  key={id.toString()}
                  class={`nav-item ${props.activeTab===option.name ?"active":""}`}
                  onClick={() => props.handleLinkClick(option.name)}
                >
                  
                  {option?.name}
                 
                </li>
              ))}
              {/* <li class="nav-item" onClick={fnChangeTheme}>
                <a class="nav-link" href="#">
                  <i class="fa fa fa-moon-o"></i>
               
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
